var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Übersicht Einspareffekte")]),_vm._v(" "),_c('Bar',{attrs:{"data":_vm.datacollection,"height":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }